// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Match create-new-part-dialog styling */
mat-dialog-content {
    padding: 2px 24px !important;
    background-color: #f0f0f0;
    min-height: 150px;
    max-height: 500px;
    overflow-y: auto;
}

.content {
    padding: 16px;
    border-radius: 4px;
}

mat-dialog-actions {
    background-color: #f0f0f0;
    padding: 12px 24px !important;
    justify-content: center;
}

.button-gap {
    gap: 12px;
}

.containers-list {
    margin-bottom: 0;
}

.container-row {
    position: relative;
}

/* Icon buttons styling */
.btn-icon-remove,
.btn-icon-search {
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
}

.btn-icon-remove:hover .icon-close {
    color: #dc3545;
}

.btn-icon-search:hover .icon-search {
    color: #0066cc;
}

.btn-icon-remove:disabled,
.btn-icon-search:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.icon-close {
    color: #dc3545;
    font-size: 20px;
    width: 20px;
    height: 20px;
}

.icon-search {
    color: #0066cc;
    font-size: 20px;
    width: 20px;
    height: 20px;
}

/* Form control */
.form-control-sm {
    height: 28px;
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    border-radius: 0.2rem;
    border: 1px solid #ced4da;
}

.form-control-sm:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Search results dropdown */
.search-results-dropdown {
    position: absolute;
    top: 100%;
    left: 32px;
    right: 64px;
    z-index: 1000;
    background: white;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    margin-top: 2px;
    max-height: 200px;
    overflow-y: auto;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.list-group-item {
    padding: 0.75rem;
    border: none;
    border-bottom: 1px solid #e9ecef;
    cursor: pointer;
    background: transparent;
    width: 100%;
    text-align: left;
}

.list-group-item:hover {
    background-color: #f8f9fa;
}

.list-group-item:last-child {
    border-bottom: none;
}

.spinner-icon {
    animation: spin 1s linear infinite;
    font-size: 14px;
    width: 14px;
    height: 14px;
    vertical-align: middle;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/add-new-spacer-modal/create-spacer-info/edit/edit.component.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,uBAAuB;AAC3B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,yBAAyB;AACzB;;IAEI,uBAAuB;IACvB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA,iBAAiB;AACjB;IACI,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,gDAAgD;AACpD;;AAEA,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;IAChC,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":["/* Match create-new-part-dialog styling */\nmat-dialog-content {\n    padding: 2px 24px !important;\n    background-color: #f0f0f0;\n    min-height: 150px;\n    max-height: 500px;\n    overflow-y: auto;\n}\n\n.content {\n    padding: 16px;\n    border-radius: 4px;\n}\n\nmat-dialog-actions {\n    background-color: #f0f0f0;\n    padding: 12px 24px !important;\n    justify-content: center;\n}\n\n.button-gap {\n    gap: 12px;\n}\n\n.containers-list {\n    margin-bottom: 0;\n}\n\n.container-row {\n    position: relative;\n}\n\n/* Icon buttons styling */\n.btn-icon-remove,\n.btn-icon-search {\n    background: transparent;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n}\n\n.btn-icon-remove:hover .icon-close {\n    color: #dc3545;\n}\n\n.btn-icon-search:hover .icon-search {\n    color: #0066cc;\n}\n\n.btn-icon-remove:disabled,\n.btn-icon-search:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.icon-close {\n    color: #dc3545;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n}\n\n.icon-search {\n    color: #0066cc;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n}\n\n/* Form control */\n.form-control-sm {\n    height: 28px;\n    padding: 0.25rem 0.5rem;\n    font-size: 0.875rem;\n    border-radius: 0.2rem;\n    border: 1px solid #ced4da;\n}\n\n.form-control-sm:focus {\n    border-color: #80bdff;\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n/* Search results dropdown */\n.search-results-dropdown {\n    position: absolute;\n    top: 100%;\n    left: 32px;\n    right: 64px;\n    z-index: 1000;\n    background: white;\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n    margin-top: 2px;\n    max-height: 200px;\n    overflow-y: auto;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.list-group-item {\n    padding: 0.75rem;\n    border: none;\n    border-bottom: 1px solid #e9ecef;\n    cursor: pointer;\n    background: transparent;\n    width: 100%;\n    text-align: left;\n}\n\n.list-group-item:hover {\n    background-color: #f8f9fa;\n}\n\n.list-group-item:last-child {\n    border-bottom: none;\n}\n\n.spinner-icon {\n    animation: spin 1s linear infinite;\n    font-size: 14px;\n    width: 14px;\n    height: 14px;\n    vertical-align: middle;\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
